<script>
	import Packages from "../components/Packages";
	import ProviderSelector from "../components/ProviderSelector";
	export default {
		components: {
			Packages,
			ProviderSelector
		}
	}
</script>
<template>
	<div class="prepaid-packages">
		<provider-selector />
		<packages />
	</div>
</template>
